export default "__VITE_ASSET__824fb660__"